import React from "react";
import PropTypes from "prop-types";
import SummaryItem from "../components/SummaryItem.jsx";
import SectionItem from "../components/SectionItem.jsx";
import EmailDelivery from "../components/EmailDelivery.jsx";
import { ServerDelivery } from "../components/ServerDelivery.jsx";

const startRecording = {
  1: "Always On",
  2: "Manual Start",
  3: "Automatic Start",
};
const storageDays = {
  30: "1 month",
  60: "2 months",
  90: "3 months",
  120: "4 months",
  150: "5 months",
  180: "6 months",
  210: "7 months",
  240: "8 months",
  270: "9 months",
  300: "10 months",
  330: "11 months",
  365: "1 year",
  730: "2 years",
  1095: "3 years",
  1460: "4 years",
  1825: "5 years",
  2190: "6 years",
  2555: "7 years",
};

const CallRecording = (props) => {
  return (
    <SummaryItem itemKey={"Call Recording: "}>
      <SectionItem itemKey={"Start Recording"}>
        {startRecording[props.module.callRecordingType]}
      </SectionItem>
      <SectionItem itemKey={"Online Playback"}>
        {props.module.showOnline ? "Yes" : "No"}
      </SectionItem>
      {props.module.showOnline && (
        <SectionItem itemKey={"Delete After"}>
          {storageDays[props.module.storageDays]}
        </SectionItem>
      )}
      <EmailDelivery emailGroup={props.module.emailGroup} />
      <ServerDelivery server={props.module.remoteServer} />
    </SummaryItem>
  );
};

export default CallRecording;

CallRecording.propTypes = {
  module: PropTypes.object,
  sites: PropTypes.array,
  clientId: PropTypes.any,
};
